{
  "familyId": "SPR-SAM-TUSSEN-S",
  "questions": [
    {
      "id": "SPR-SAM-TUSSEN-S-001",
      "familyId": "SPR-SAM-TUSSEN-S",
      "module": "SpellingRegel",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "samenstelling",
      "subSkill": "samenst_tussen_s",
      "questionType": "multiple_choice",
      "question": "Welke spelling is correct?",
      "options": ["dorpsplein", "dorpplein", "dorppen plein", "dorps plein"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {"type": "rule", "showWhen": "wrong", "data": {"title": "Tussen-s", "content": "Bij sommige samenstellingen voeg je een -s toe tussen de twee delen. Dit heet de tussen-s.\n\nTip: spreek het woord hardop uit. Hoor je een -s? Dan schrijf je die ook.\ndorp + plein → dorpsplein (je hoort de s)\nstad + muur → stadsmuur (je hoort de s)", "icon": "lightbulb"}}
      ],
      "conceptId": "tussen_s_basis",
      "variantIndex": 1,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Spreek het woord hardop uit: 'dorpsplein'. Je hoort duidelijk een -s tussen 'dorp' en 'plein'. Die -s schrijf je ook: dorpsplein. Samenstellingen schrijf je altijd aan elkaar, dus niet 'dorps plein' of 'dorppen plein'.",
        "solutionSteps": [
          "Herken de samenstelling: dorp + plein",
          "Spreek het hardop uit: je hoort 'dorps-plein'",
          "Schrijf de -s die je hoort: dorpsplein",
          "Aan elkaar schrijven (het is één woord)"
        ],
        "distractorExplanations": {
          "0": "Goed! Dorp + s + plein = dorpsplein. Je hoort de -s als je het uitspreekt.",
          "1": "Je bent de tussen-s vergeten. Spreek het hardop uit: je hoort 'dorps-plein', niet 'dorp-plein'. Schrijf de -s die je hoort.",
          "2": "Je hebt het woord gesplitst en 'dorppen' geschreven. Maar het is één woord: dorpsplein. Samenstellingen schrijf je aan elkaar.",
          "3": "Je hebt de tussen-s wel, maar het woord gesplitst. Samenstellingen schrijf je aan elkaar: dorpsplein, niet 'dorps plein'."
        }
      }
    },
    {
      "id": "SPR-SAM-TUSSEN-S-002",
      "familyId": "SPR-SAM-TUSSEN-S",
      "module": "SpellingRegel",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "samenstelling",
      "subSkill": "samenst_tussen_s",
      "questionType": "multiple_choice",
      "question": "Welk woord heeft een tussen-s?",
      "options": ["boekenkast", "pannenlap", "koningshuis", "fietsenrek"],
      "correctAnswer": 2,
      "stimulusAids": [],
      "supportAids": [
        {"type": "rule", "showWhen": "wrong", "data": {"title": "Tussen-s of tussen-en?", "content": "Sommige samenstellingen hebben een tussen-s, andere een tussen-en.\n\nTussen-s: koningshuis, dorpsplein, stadsmuur\nTussen-en: boekenkast, pannenlap, fietsenrek\n\nTip: spreek het woord uit. Hoor je -s of -en? Schrijf wat je hoort.", "icon": "lightbulb"}}
      ],
      "conceptId": "tussen_s_herkennen",
      "variantIndex": 2,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Koningshuis heeft een tussen-s: koning + s + huis. Spreek het uit: 'konings-huis'. De andere woorden hebben een tussen-en: boeken-kast, pannen-lap, fietsen-rek. Tip: luister goed naar wat je hoort tussen de twee delen.",
        "solutionSteps": [
          "Koningshuis: koning + s + huis (je hoort -s)",
          "Boekenkast: boek + en + kast (je hoort -en)",
          "Pannenlap: pan + en + lap (je hoort -en)",
          "Fietsenrek: fiets + en + rek (je hoort -en)"
        ],
        "distractorExplanations": {
          "0": "Boekenkast heeft een tussen-en, niet een tussen-s. Spreek het uit: boeken-kast. Je hoort -en, niet -s.",
          "1": "Pannenlap heeft een tussen-en: pannen-lap. Je hoort -en, niet -s.",
          "2": "Goed! Koningshuis heeft een tussen-s: konings + huis.",
          "3": "Fietsenrek heeft een tussen-en: fietsen-rek. Je hoort -en, niet -s."
        }
      }
    },
    {
      "id": "SPR-SAM-TUSSEN-S-003",
      "familyId": "SPR-SAM-TUSSEN-S",
      "module": "SpellingRegel",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "samenstelling",
      "subSkill": "samenst_tussen_s",
      "questionType": "multiple_choice",
      "question": "Welke spelling is FOUT?",
      "options": ["schaapskooi", "schaapherder", "stadsmuur", "landbouwgrond"],
      "correctAnswer": 1,
      "stimulusAids": [],
      "supportAids": [
        {"type": "rule", "showWhen": "wrong", "data": {"title": "Schaap + s", "content": "Bij 'schaap' hoor je een -s in samenstellingen: schaaps-herder, schaaps-kooi.\n\nSpreek het hardop uit: 'schaapherder' klinkt onhandig, 'schaapsherder' klinkt natuurlijk. Schrijf de -s die je hoort.", "icon": "lightbulb"}}
      ],
      "conceptId": "tussen_s_fout",
      "variantIndex": 3,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "'Schaapherder' mist de tussen-s. Spreek het hardop uit: je hoort 'schaaps-herder', niet 'schaap-herder'. Het moet 'schaapsherder' zijn. De andere woorden zijn correct: schaapskooi, stadsmuur, landbouwgrond.",
        "solutionSteps": [
          "Spreek elk woord hardop uit",
          "Schaapherder → klinkt onhandig, mist de -s",
          "Correct: schaapsherder",
          "De andere woorden klinken goed zoals ze zijn"
        ],
        "distractorExplanations": {
          "0": "Schaapskooi is correct — met tussen-s. De fout zit in 'schaapherder' (mist de -s).",
          "1": "Goed gevonden! 'Schaapherder' moet 'schaapsherder' zijn — met tussen-s.",
          "2": "Stadsmuur is correct: stad + s + muur. De fout zit in 'schaapherder'.",
          "3": "Landbouwgrond is correct: landbouw + grond (geen verbindingsklank nodig). De fout zit in 'schaapherder'."
        }
      }
    },
    {
      "id": "SPR-SAM-TUSSEN-S-004",
      "familyId": "SPR-SAM-TUSSEN-S",
      "module": "SpellingRegel",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "samenstelling",
      "subSkill": "samenst_tussen_s",
      "questionType": "multiple_choice",
      "question": "Welke samenstelling is correct geschreven?",
      "options": ["arbeidtijd", "arbeids tijd", "arbeid-tijd", "arbeidstijd"],
      "correctAnswer": 3,
      "stimulusAids": [],
      "supportAids": [
        {"type": "rule", "showWhen": "wrong", "data": {"title": "Tussen-s bij lange woorden", "content": "Bij langere woorden hoor je vaak een -s als verbinding:\narbeid + s + tijd = arbeidstijd\noverheid + s + beleid = overheidsbeleid\n\nSpreek het uit en schrijf wat je hoort. Samenstellingen schrijf je aan elkaar.", "icon": "lightbulb"}}
      ],
      "conceptId": "tussen_s_uitgang",
      "variantIndex": 4,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Spreek het uit: 'arbeids-tijd'. Je hoort een -s tussen 'arbeid' en 'tijd'. Schrijf die -s: arbeidstijd. Het woord wordt aan elkaar geschreven — geen spatie of streepje.",
        "solutionSteps": [
          "Spreek het uit: arbeids-tijd (je hoort -s)",
          "Schrijf de -s: arbeidstijd",
          "Aan elkaar (het is één woord)"
        ],
        "distractorExplanations": {
          "0": "Je bent de tussen-s vergeten. Spreek het uit: je hoort 'arbeids-tijd', niet 'arbeid-tijd'.",
          "1": "Samenstellingen schrijf je aan elkaar, niet los. Het is 'arbeidstijd', niet 'arbeids tijd'.",
          "2": "Een streepje is hier niet nodig. Samenstellingen schrijf je aan elkaar: arbeidstijd.",
          "3": "Goed! Arbeidstijd — met tussen-s, aan elkaar geschreven."
        }
      }
    },
    {
      "id": "SPR-SAM-TUSSEN-S-005",
      "familyId": "SPR-SAM-TUSSEN-S",
      "module": "SpellingRegel",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "samenstelling",
      "subSkill": "samenst_tussen_s",
      "questionType": "fill_in",
      "question": "Maak een samenstelling van 'stad' en 'park'. Typ het hele woord.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["stadspark"],
        "caseSensitive": false,
        "placeholder": "typ het woord"
      },
      "stimulusAids": [],
      "supportAids": [
        {"type": "rule", "showWhen": "wrong", "data": {"title": "Stad + s + park", "content": "Spreek het uit: 'stads-park'. Je hoort een -s. Schrijf die -s: stadspark.\n\nAndere voorbeelden: stadsmuur, stadscentrum, stadsbus.", "icon": "lightbulb"}}
      ],
      "conceptId": "tussen_s_fill",
      "variantIndex": 5,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Spreek het uit: 'stads-park'. Je hoort een -s tussen 'stad' en 'park'. Schrijf die -s: stadspark. Andere voorbeelden met stad: stadsmuur, stadscentrum.",
        "solutionSteps": [
          "Spreek het uit: stads-park",
          "Je hoort een -s",
          "Schrijf: stadspark"
        ]
      }
    }
  ]
}